<template>
<div class="container mt-4">
    <div class="mb-3" style="font-size: 18px;font-weight: bold;">List Template</div>
    <table class="table table-bordered table-striped">
        <thead class="mt-2">
            <tr>
                <th>No</th>
                <th>Name</th>
                <th>Parameters</th>
                <th>Description</th>
                <th>Edit</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="(item, index) in list_template" :key="index">
                <td class="text-center">{{ index+1 }}</td>

                <td>{{ item.name }}</td>
                <td>{{ item.device_items?.length || 0 }}</td>
                <td>{{item.description}}</td>
                <td class="text-center">
                    <button @click="template=item,items=template.device_items,itemForm={}" type="button" class="btn text-white py-1 px-2 rounded-4" data-bs-toggle="modal" data-bs-target="#editTemplateModal" style="background-color: rgb(47, 144, 220); font-size: 14px;">
                        <font-awesome-icon :icon="['fas', 'pen']" /> Edit
                    </button>
                    <button @click="deleteTemplate(item.id)" type="button" class="btn btn-danger text-white py-0 ms-1 py-1 px-2 rounded-4" style="font-size: 14px;">Delete</button>
                </td>
            </tr>
        </tbody>
    </table>

    <!-- Modal -->
    <div class="modal fade" id="editTemplateModal" tabindex="-1" aria-labelledby="editTemplateModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-xl">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="editTemplateModalLabel">Edit Template</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="row mt-2">
                        <div class="col-md-6">
                            <div class="mb-3">
                                <label class="form-label"><i class="bi bi-envelope"></i> Template Name</label>
                                <input type="text" class="form-control" placeholder="Name" v-model="template.name">
                            </div>
                            <div>Add Item</div>
                            <div class="bg-light rounded-4 px-3 py-3" style="font-size: 14px;">
                                <div class="row mt-2">
                                    <div class="col-3 text-end">
                                        Data Type
                                    </div>
                                    <div class="col-9">
                                        <select v-model="itemForm.type" class="col-12" style="height: 35px;">
                                            <option disabled value="">Please select Data type</option>
                                            <option>Data</option>
                                            <option>Control</option>
                                        </select>
                                        <!-- <input type="text" class="form-control" placeholder="" v-model="template.value_type"> -->
                                    </div>
                                </div>
                                <div class="row mt-2">
                                    <div class="col-3 text-end">
                                        Label
                                    </div>
                                    <div class="col-9">
                                        <input type="text" class="form-control" placeholder="eg. Voltage 1" v-model="itemForm.label">
                                    </div>
                                </div>
                                <div class="row mt-2">
                                    <div class="col-3 text-end">
                                        Key
                                    </div>
                                    <div class="col-9">
                                        <input type="text" class="form-control" placeholder="eg. v1" v-model="itemForm.key">
                                    </div>
                                </div>
                                <div class="row mt-2">
                                    <div class="col-3 text-end">
                                        Value Type
                                    </div>
                                    <div class="col-9">
                                        <select v-model="itemForm.value_type" class="col-12" style="height: 35px;">
                                            <option disabled value="">Please select type</option>
                                            <option>Float</option>
                                            <option>Int</option>
                                            <option>bool</option>
                                        </select>
                                        <!-- <input type="text" class="form-control" placeholder="" v-model="template.value_type"> -->
                                    </div>
                                </div>
                                <div class="row mt-2">
                                    <div class="col-3 text-end">
                                        Unit
                                    </div>
                                    <div class="col-9">
                                        <input type="text" class="form-control" placeholder="" v-model="itemForm.unit">
                                    </div>
                                </div>

                                <div class="row mt-2">
                                    <!-- <div class="col-3 text-end">
                                        Widget Type
                                    </div>
                                    <div class="col-9">
                                        <select v-model="template.widget_type" class="col-12" style="height: 35px;">
                                            <option disabled value="">Please select widget type</option>
                                            <option>realtime</option>
                                            <option>gauge</option>
                                            <option>chart</option>
                                            <option>notification</option>
                                        </select>
                                    </div> -->
                                    <!-- <div class="col-9">
                            <input type="text" class="form-control" placeholder="" v-model="template.widget_type">
                        </div> -->
                                </div>
                                <div v-if="edit_state==false" class="text-end mt-3">
                                    <button type="button" v-if="edit_state==false" class="btn btn-light bg-white border" @click="addItemToTemplate()">+ Add
                                        Item</button>
                                </div>
                                <div v-else class="text-end mt-3">
                                    <button type="button"  class="btn btn-light bg-danger" @click="cancleItemEdit">X Cancle</button>
                                    <button type="button"  class="btn btn-light bg-white border" @click="saveItemEdit()">Edit Item</button>
                                </div>
                            </div>

                        </div>
                        <!-- Right Section -->
                        <div class="col-md-6">
                            <div>List Items</div>
                            <div style="height: 250px;" class=" rounded-4 bg-light overflow-auto">
                                <div class="row px-2 py-2">

                                    <div class="col-6" v-for="(item,index) in items" :key="item">
                                        <div class="rounded-5 px-2 py-1 mt-2" style=" border: 1px solid #2F90DC;" @click="editItem(item,index)">
                                            <div class="row">
                                                <div class="col-10">
                                                    {{ item.label }}
                                                </div>
                                                <div class="col-2">
                                                    <font-awesome-icon class="" type="button" @click="items.splice(index, 1);" style="color: red;font-size: 20px;" :icon="['fas', 'circle-xmark']" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="mb-3 mt-3">
                                <label class="form-label"><i class="bi bi-bookmark"></i>Description</label>
                                <textarea class="form-control rounded-4" rows="4" placeholder="" v-model="template.description"></textarea>
                            </div>
                        </div>
                    </div>

                    <!-- Buttons -->
                    <div class="d-flex justify-content-end mt-4">
                        <!-- <button class="btn btn-danger px-4" @click="clearForm">
                            <i class="bi bi-brush"></i> Clear
                        </button> -->
                        <button class="btn btn-secondary px-4" @click="editTemplate(template.id)" data-bs-dismiss="modal">
                            <font-awesome-icon :icon="['fas', 'pen-to-square']" /> Edit Template
                        </button>
                    </div>

                </div>
            </div>
        </div>
    </div>

</div>
</template>

<script>
export default {
    data() {
        return {
            editIndex: null,
            edit_state: false,
            list_template: [],
            items: [],
            template: { // ใช้สำหรับข้อมูลของ template เท่านั้น
                id: null,
                name: "",
                description: ""
            },
            itemForm: { // ใช้สำหรับเพิ่ม/แก้ Item
                label: "",
                key: "",
                value_type: "",
                unit: "",
                widget_type: "",
                type:""
            },
            toastMsg: "" // เอาไว้แสดงสถานะสั้นๆ
            // template: {
            //     label: "",
            //     name: "",
            //     key: "",
            //     value_type: "",
            //     unit: "",
            //     widget_type: "",
            //     description: ""
            // },
        };
    },
    methods: {
        addItemToTemplate() {
            this.items.push({
                label: this.itemForm.label,
                key: this.itemForm.key,
                value_type: this.itemForm.value_type,
                unit: this.itemForm.unit,
                widget_type: this.itemForm.widget_type,
                type:this.itemForm.type
            })
            this.itemForm.label = ""
            this.itemForm.key = ""
            this.itemForm.value_type = ""
            this.itemForm.unit = ""
            this.itemForm.widget_type = ""
            this.itemForm.type = ""

        },
        saveItemEdit() {
            if (this.editIndex !== null) {
            // อัปเดต items[index] ด้วยค่าจาก template
            this.items[this.editIndex] = JSON.parse(JSON.stringify(this.itemForm));
            this.edit_state = false;
            // this.template = {
            //   label: "",
            //   key: "",
            //   value_type: "",
            //   unit: "",
            //   widget_type: ""
            // };
            // this.template= { // ใช้สำหรับข้อมูลของ template เท่านั้น
            //             id: null,
            //             name: "",
            //             description: ""
            //         },
                    this.itemForm= { // ใช้สำหรับเพิ่ม/แก้ Item
                        label: "",
                        key: "",
                        value_type: "",
                        unit: "",
                        widget_type: "",
                        type:""

                    }
            this.editIndex = null;
            }
        },
    editItem(item, index) {
    this.editIndex = index; // จดจำ index ของ item ที่ถูก edit
    // this.template = JSON.parse(JSON.stringify(item)); // สำเนาเพื่อแก้ไข
    this.itemForm = JSON.parse(JSON.stringify(item)); // สำเนาเพื่อแก้ไข
    this.edit_state = true;
  },
        cancleItemEdit(){
            this.itemForm= { // ใช้สำหรับเพิ่ม/แก้ Item
                        label: "",
                        key: "",
                        value_type: "",
                        unit: "",
                        widget_type: "",
                        type:""
                    }
    this.edit_state = false;
        },

        async getTemplateList() {
            try {
                this.list_template = [{
                    "name": "name1",
                    "description": "this.template.description",
                    "items": "[this.items]"
                }];
                var accessToken = localStorage.getItem("accessToken");
                const response = await fetch(`${process.env.VUE_APP_API_URL}/api/devices/template`, {
                    method: "GET",
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${accessToken}`
                    }
                });
                const data = await response.json();
                console.log("success:", data);
                this.list_template = data.data;
            } catch (error) {
                console.error("Upload error:", error);
            }
        },

        copyTextFallback(text) {
            const textarea = document.createElement("textarea");
            textarea.value = text;
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand("copy");
            document.body.removeChild(textarea);
        },

        async deleteTemplate(id) {
            try {
                var accessToken = localStorage.getItem("accessToken");
                const response = await fetch(`${process.env.VUE_APP_API_URL}/api/devices/template?templateid=` + id, {
                    method: 'DELETE',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${accessToken}`
                    }
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                this.getTemplateList();
            } catch (error) {
                console.error('Error fetching dashboard data:', error);
            }

        },
        async editTemplate(id) {
            try {

                var accessToken = localStorage.getItem("accessToken");
                const response = await fetch(`${process.env.VUE_APP_API_URL}/api/devices/template`, {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${accessToken}`
                    },
                    body: JSON.stringify({
                        "id": id,
                        "name": this.template.name,
                        "description": this.template.description,
                        "items": this.items
                    })
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const result = await response.json();
                this.getTemplateList();
                console.log('Dashboard page created:', result);
            } catch (error) {
                console.error('Error creating dashboard page:', error);
            }

        },
        async editDevice(id) {
            try {
                var body_create_device;
                if (this.device.mode == 'api') {
                    if (this.api.type == 'apikey') {
                        body_create_device = {
                            "id": id,
                            "name": this.device.name,
                            "comment": this.device.comment,
                            "mode": this.device.mode,
                            "config": {
                                "auth": {
                                    "type": this.api.type,
                                    "in": this.api.in,
                                    "key": this.api.key,
                                    "value": this.api.value
                                },
                                "deviceId": this.device.model
                            }
                        }
                    } else {
                        body_create_device = {
                            "id": id,
                            "name": this.device.name,
                            "comment": this.device.comment,
                            "mode": this.device.mode,
                            "config": {
                                "auth": {
                                    "type": this.api.type,
                                    "username": this.api.username,
                                    "password": this.api.password,
                                },
                                "deviceId": this.device.model
                            }
                        }
                    }
                } else if (this.device.mode == 'mqtt') {
                    body_create_device = {
                        "id": id,
                        "name": this.device.name,
                        "comment": this.device.comment,
                        "mode": this.device.mode,
                        "config": {
                            "auth": {
                                "topic": this.mqtt.topic,
                                "id": this.mqtt.id,
                                "username": this.mqtt.username,
                                "password": this.mqtt.password,
                            },
                            "deviceId": this.device.model
                        }
                    }
                }

                var accessToken = localStorage.getItem("accessToken");
                const response = await fetch(`${process.env.VUE_APP_API_URL}/api/devices`, {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${accessToken}`
                    },
                    body: JSON.stringify(
                        body_create_device
                    )
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const result = await response.json();
                this.$router.push('/user/listuser');

                console.log('Dashboard page created:', result);
            } catch (error) {
                console.error('Error creating dashboard page:', error);
            }
        },

        async getAllDevice() {
            try {
                var accessToken = localStorage.getItem("accessToken");
                const response = await fetch(`${process.env.VUE_APP_API_URL}/api/devices/all`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${accessToken}`
                    }
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const data = await response.json();
                this.list_device = data.data;
            } catch (error) {
                console.error('Error fetching dashboard data:', error);
            }

        },
    },
    mounted() {
        this.getTemplateList();
        this.getAllDevice()
    },
};
</script>
